export default {
  duration: 'Doba trvania',
  recipeStepUp: 'Presunúť krok receptu nahor',
  recipeStepDown: 'Presunúť krok receptu nadol',
  recipeStepDuplicate: 'Duplikovať krok receptu',
};
